import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

// export default new Router({
//   routes: [
//     {
//       path: '/',
//       name: 'HelloWorld',
//       component: HelloWorld
//     }
//   ]
// })

export const constantRouterMap = [
  {
      path: '/',
      name: 'home',
      component: () =>
          import ('@/views/Home/home')
  },
  {
      path: '/about',
      name: 'about',
      component: () =>
          import ('@/views/Home/about')
  },
  {
    path: '/financeReport',
      name: 'financeReport',
      component: () =>
          import ('@/views/Finance-Reporting/index')
  },
  {
    path: '/financeSystem',
      name: 'financeSystem',
      component: () =>
          import ('@/views/Finance-System/index')
  },
  {
    path: '/talent',
      name: 'talent',
      component: () =>
          import ('@/views/Talent/index')
  },
  {
    path: '/news',
      name: 'news',
      component: () =>
          import ('@/views/News/news')
  },
  {
    path: '/support',
      name: 'support',
      component: () =>
          import ('@/views/Support/support')
  }
  ,
  {
    path: '/intake',
      name: 'intake',
      component: () =>
          import ('@/views/Intake/intake')
  },
  {
    path: '/newsArticle',
      name: 'newsArticle',
      component: () =>
          import ('@/views/News/newsArticle')
  },
  {
    path: '/newsDetail',
      name: 'newsDetail',
      component: () =>
          import ('@/views/News/newsDetail')
  }
]
export default new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  // base: process.env.VUE_APP_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js